import { Card, CardBody, Col, Row } from 'reactstrap'
import ModalOne from './ModalOne/ModalOne'
import ModalTwo from './ModalTwo/ModalTwo'
import ModalThird from './ModalThird/ModalThird'
import CardHeaderCommon from '../../../../Utils/CommonComponents/CardHeaderCommon'
import { customModalData } from '../../../../Data/Ui-Kits/Modal/Modal'
import { LagosCustomModal } from '../../../../Utils/Constants'

const MofiCustomModals = () => {
  return (
    <Col sm="12">
      <Card>
        <CardHeaderCommon title={LagosCustomModal} span={customModalData} />
        <CardBody>
          <Row className="g-3">
            <ModalOne />
            <ModalTwo />
            <ModalThird />
          </Row>
        </CardBody>
      </Card>
    </Col>
  )
}

export default MofiCustomModals